var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5,55c15.19,0,27.5-12.31,27.5-27.5S42.69,0,27.5,0,0,12.31,0,27.5s12.31,27.5,27.5,27.5ZM30.42,26.28l9.53-11.67h-2.26l-8.27,10.13-6.61-10.13h-7.62l9.99,15.32-9.99,12.24h2.26l8.74-10.7,6.98,10.7h7.62l-10.36-15.89h0ZM27.32,30.07l-1.01-1.53-8.06-12.14h3.47l6.5,9.8,1.01,1.53,8.45,12.74h-3.47l-6.9-10.39h0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/x-logo.f2be49ec4b0ed48bcbbe2c64fba7343c.svg";
export { ForwardRef as ReactComponent };